import { makeStyles } from '@material-ui/core';
import React from 'react';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import clsx from 'clsx';
import { qualitySampleResults } from '../../../Config/constants';

export default function YesNoQualityCheck(props) {
    const classes = useStyles();

    const StyledRadioButton = (props) => {

        return (<Radio
            className={classes.radioButton}
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />)
    }

    return (
        <div className={classes.boolQualityCheck}>
            <div className={classes.title}>
                {props.qualityCheck.description}
            </div>
            <div className={classes.description}>
                {props.qualityCheck.question}
            </div>
            <div>
                <div>
                    <RadioGroup className={classes.radioGroup} aria-label="gender" value={props.qualityCheck.result ===  qualitySampleResults.OK} onChange={(e) => props.qualityCheckChanged(e, props.qualityCheck.code)}>
                        <div className={clsx({ [classes.true]: !props.qualityCheck.result !== qualitySampleResults.OK, [classes.trueChecked]: props.qualityCheck.result ===  qualitySampleResults.OK})}>
                            <FormControlLabel className={classes.formControl} value={true} control={<StyledRadioButton />} label={<img className={classes.trueIcon} alt="planned" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>} />
                            
                        </div>
                        <div className={clsx({ [classes.false]: props.qualityCheck.result ===  qualitySampleResults.OK , [classes.falseChecked]: props.qualityCheck.result !==  qualitySampleResults.OK })}>
                            <FormControlLabel className={classes.formControl} value={false} control={<StyledRadioButton />} label={<ClearRoundedIcon className={classes.falseIcon}></ClearRoundedIcon>} />
                            {/* <ClearRoundedIcon className={classes.falseIcon}></ClearRoundedIcon> */}
                        </div>
                    </RadioGroup>
                </div>
                <div>
                </div>
            </div>
        </div>)


}

const useStyles = makeStyles({
    description: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
    },
    trueIcon:{
        marginLeft: '20px',
        marginRight: '25px',
    },
    title: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
        fontWeight: "bold"
    },
    icon: {
        borderRadius: '50%',
        width: 20,
        height: 20,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: "white",
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 26,
            height: 26,
            backgroundImage: 'radial-gradient(' + FlagstoneTheme.palette.primary.main + ',' + FlagstoneTheme.palette.primary.main + ' 28%,transparent 32%)',
            content: '""',
            position: "relative",
            bottom: "3px",
            right: "3px"
        },
    },
    boolQualityCheck: {
        width: "100%",
        marginTop: "20px",
        marginBottom:"20px"
    },
    formControl: {
        float: "left"
    },
  
    falseIcon: {
        float: "left",
        color: "#D84949",
        width: "30px",
        height: '30px',
        marginLeft: '10px',
        marginRight: '25px'
    },
    true: {
        float: "left",
        '& > label': {
            marginRight: "0px !important"
        },
        borderRadius: "5px",
        paddingLeft: "10px",
        border: "1px solid #DEDEDE",
        marginRight: "10px"
    },
    false: {
        float: "left",
        '& > label': {
            marginRight: "0px !important"
        },
        borderRadius: "5px",
        paddingLeft: "10px",
        border: "1px solid #DEDEDE"
    },
    trueChecked: {
        float: "left",
        '& > label': {
            marginRight: "0px !important"
        },
        backgroundColor: "#C4EFC2",
        borderRadius: "5px",
        paddingLeft: "10px",
        marginRight: "10px"
    },
    falseChecked: {
        float: "left",
        '& > label': {
            marginRight: "0px !important"
        },
        backgroundColor: "#FFEBEB",
        borderRadius: "5px",
        paddingLeft: "10px"
    },
    radioGroup: {
        flexDirection: "row",
        marginTop: "10px"
    },
});